module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list-orders"
  }, [_c('div', {}, [_c('h1', {
    staticClass: "title primary-text"
  }, [_vm._v(_vm._s(_vm.$t("eStore.title")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showMsgListOrder) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Liste vide")])]) : _vm._e(), _vm._v(" "), (_vm.hideArray) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Contactez votre admin, Error " + _vm._s(_vm.getOrdersList.code))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 order-md-2 detail-content"
  }, [(!_vm.hideArray) ? _c('table', {
    staticClass: "table table-hover table-detail"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("eStore.name")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("eStore.brand")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("eStore.zone")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("eStore.status")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("eStore.last")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getOrdersList), function(order) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(order.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.brand.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.zone.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTranslate(order.status.name)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.modifiedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('router-link', {
      staticClass: "btn",
      attrs: {
        "to": {
          path: '/list-orders/detail/' + order.id
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("eStore.details")) + "\n                                ")])], 1)])
  }))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b7b2a7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eStore/ListOrders.vue
// module id = 3006
// module chunks = 0